const activeClass = 'active-dd';

$('.header .has-dropdown > a, header .has-megamenu > a').on('click', function(event) {
  event.preventDefault();

  const $this = $(this);

  $this
    .siblings()
    .slideToggle()
    .parent()
    .toggleClass(activeClass)
    .siblings()
    .removeClass(activeClass)
    .find('.dropdown, .megamenu')
    .slideUp();
});
